import { reduxKey } from './constants';
export var config = function (state) { return state[reduxKey] || {}; };
export var key = function (name) { return function (state) { return config(state)[name]; }; };
export var getConfig = config;
export var getConfigKey = function (state, name) {
    return config(state)[name];
};
//# sourceMappingURL=selectors.js.map